//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { IModerationItem } from '@components/moderation-grid/moderationGridModel';
import { IItemMetadataSocialDetails } from '@models/IItemMetadata';
import { PRODUCT_ERROR_FILTER_VALUE } from '@tagging/constants/taggingConstants';

export interface ITaggingPaginatedViewProps {
  pageNumber: number;
}

export interface ITaggingSource {
  source: TaggingSourceType;
  label: string;
  mediaCount: number;
  isEnabled: boolean;
}

export interface ITaggingFeedMetadata {
  acId: string;
  headline: string;
  landingPageUrl: string;
}

export type TaggingGridLayout = 'grid' | 'grid-details';

export type TaggingFeedCounts = Record<TaggingFeedType, number>;

export interface ITaggingFeedItem extends IModerationItem {
  feedMetadata: ITaggingFeedMetadata;
}

export enum TaggingFeedType {
  Published = 'published',
  NeedsProducts = 'needsProducts',
  NeedsReview = 'needsReview',
  ReadyToPublishTaggingServices = 'readyToPublishTaggingServices',
  ReadyToPublish = 'readyToPublish',
  Trash = 'trash',
}

export type BulkPublishableTaggingFeedType = TaggingFeedType.ReadyToPublish
| TaggingFeedType.ReadyToPublishTaggingServices;

export enum TaggingSourceType {
  UPLOADED = 'UPLOADED',
  INSTAGRAM = 'INSTAGRAM',
  FACEBOOK = 'FACEBOOK',
  GOOGLE_DRIVE = 'GOOGLE_DRIVE',
  DROPBOX = 'DROPBOX',
  TWITTER = 'TWITTER',
}

export enum LandingPageType {
  DynamicLandingPage = 'dynamicLandingPage',
  StaticLandingPage = 'staticLandingPage',
}

export interface ITaggingFeedState {
  feed: ITaggingFeedItem[];
  totalFeedItemCount: number;
  taggingFeedType: TaggingFeedType;
  isFetchingFeed: boolean;
  currentPageNumber: number;
  gridLayoutValue: TaggingGridLayout;
  isFetchingFeedCounts: boolean;
  feedCounts: TaggingFeedCounts;
  isPublishAllModalOpen: boolean;
  lastPublishedItemCount: number;
  isPublishingItems: boolean;
  isRemovingItems: boolean;
  isItemDetailsModalOpen: boolean;
  itemDetailsModalSelectedItem?: IItemDetailsModalItem;
  isGeneratingFeed: boolean;
  isFetchingInitialFeedGenerationStatus: boolean;
  productErrorFilterValue: PRODUCT_ERROR_FILTER_VALUE;
  searchTextValue: string;
}

export interface IItemDetailsModalItem {
  item: ITaggingFeedItem;
  socialMetadata?: IItemMetadataSocialDetails;
}

export interface ITaggingSettings {
  headline: string;
  dynamicLandingPageUrl?: string;
  staticLandingPageUrl?: string;
  landingPageType: LandingPageType;
  jobStatus?: IJobStatus;
}

export interface IJobStatus {
  isRunning: boolean;
}

export interface ITaggingSettingsState {
  isFirstRun: boolean;
  settings: ITaggingSettings;
  dynamicLandingPageSiteName?: string;
  isFetchingSettings: boolean;
  hasFetchedSettingsOnce: boolean;
  isSavingSettings: boolean;
  isSettingsModalOpen: boolean;
  isFetchingDynamicLandingPageSiteName: boolean;
}
